<e-dialog
  [open]="target() !== null"
  (openChange)="onOpenChange($event)"
  [title]="text().title"
  [titleData]="target()?.chartName ?? ''"
  size="md"
>
  <ng-template>
    <div class="set-groups-form">
      <ng-select
        class="set-groups-select"
        appendTo="body"
        [items]="groupOptions()"
        bindValue="value"
        bindLabel="label"
        [multiple]="true"
        [closeOnSelect]="false"
        [clearable]="true"
        [placeholder]="text().placeholder"
        [ngModel]="selectedIds()"
        (ngModelChange)="selectedIds.set($event ?? [])"
      ></ng-select>

      <div class="set-groups-actions">
        <button eBtn color="highlight" icon="plus" class="set-groups-new-group"
                data-test-id="set-groups-new-group" (click)="requestCreateGroup()">{{ text().newGroup }}</button>
        <button eBtn color="highlight" (click)="onOpenChange(false)">{{ text().cancel }}</button>
        <button eBtn color="primary-75" (click)="save()">{{ text().save }}</button>
      </div>
    </div>
  </ng-template>
</e-dialog>
